// Vinci Inc. — Vinci Trade Asia. Content + curated imagery.
export const BRAND = {
  name: "Vinci Inc.",
  short: "VINCI",
  motto: "Veni · Vidi · Vici",
  slogan: "Crafted for Constructions",
  tagline: "Sourcing the world's finest construction materials — in bulk, without compromise.",
  email: "trade@realtymaze.com",
  altEmail: "vinci.connect@vincitradeasia.com",
  phones: ["+91 9867276207", "+91 9326552067"],
  // Small-print regulatory line (shown in footer + legal pages).
  enquiry: "Vinci Incorporation, Powai, Mumbai India is an independent entity dealing in core bulk trade vertical PAN India. Vinci Inc uses technology which is powered by 100% automated modules & softwares.",
  // Legacy alias — kept so `BRAND.presence` references still resolve to the
  // same fine-print string.  New code should prefer `BRAND.enquiry`.
  presence: "Vinci Incorporation, Powai, Mumbai India is an independent entity dealing in core bulk trade vertical PAN India. Vinci Inc uses technology which is powered by 100% automated modules & softwares.",
  // Registered corporate address (Vinci Inc. · World One Trade).
  address: {
    company: "Vinci Inc. · World One Trade",
    lines: [
      "6th Floor, WeWork Lightbridge",
      "Hiranandani Business Park",
      "Saki Vihar Road",
      "Chandivali / Powai · Tunga Village",
    ],
    city: "Mumbai",
    district: "Mumbai Suburban",
    state: "Maharashtra",
    pincode: "400072",
  },
};

export const IMAGES = {
  heroPrimary: "https://images.unsplash.com/photo-1781522880528-23804c610b9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroAlt: "https://images.unsplash.com/photo-1768927021770-61d689ec8332?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  steelDark: "https://images.unsplash.com/photo-1550041462-7e8602a4c4bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  steelRed: "https://images.unsplash.com/photo-1763771420316-4f01bb568273?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  steelPersp: "https://images.unsplash.com/photo-1623428454598-1bfe414bac03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cement: "https://images.unsplash.com/photo-1621121013599-c94f85975cfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cementFactory: "https://images.unsplash.com/photo-1666219462105-2909c2d72d01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  logisticsYard: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  logisticsShip: "https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  projSkyscraper: "https://static.prod-images.emergentagent.com/jobs/a9693ec3-09f6-416c-b54b-cd013db3c0d9/images/8f57875ae302e68a113802b21b7ba6c67be48a4a0076d1532b29fea15de2e196.jpeg",
  projPort: "https://static.prod-images.emergentagent.com/jobs/a9693ec3-09f6-416c-b54b-cd013db3c0d9/images/4b15ab8099d2a128c53d26e949dbf8d9fb932a4aa275ac6dfbf3629954e65e8b.jpeg",
  projBridge: "https://static.prod-images.emergentagent.com/jobs/a9693ec3-09f6-416c-b54b-cd013db3c0d9/images/ac3b26a49cfdb5ae527766fd2b876520713e61b1e7130e844296238fb9e6ddb5.jpeg",
  projSteelplant: "https://static.prod-images.emergentagent.com/jobs/a9693ec3-09f6-416c-b54b-cd013db3c0d9/images/7acfc62e6b31d902e6545d9d499c41cacce4c8457f7e4a0bfb1e4cc08bacc570.jpeg",
  projExpressway: "https://static.prod-images.emergentagent.com/jobs/a9693ec3-09f6-416c-b54b-cd013db3c0d9/images/d3d9967164354954b028e16dcae2def82154b90cb5d8336262a0aa047b487f0d.jpeg",
  projTowerComplex: "https://static.prod-images.emergentagent.com/jobs/a9693ec3-09f6-416c-b54b-cd013db3c0d9/images/68c67b2ce89027cbd93eaeafb552dd53bae3528a72b8cb4cb13c066c9fff2f20.jpeg",
  groupBanner: "https://static.prod-images.emergentagent.com/jobs/a9693ec3-09f6-416c-b54b-cd013db3c0d9/images/d7a8fb9dbc74b70a0404ea961a2cdd48548a0b99a392a0a4638def0a5f2002a3.jpeg",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Bulk, engineered.",
    body: "Vinci Inc. supplies world-class cement and steel at scale — a fully automated, transparent onboarding process with zero tolerance for friction.",
  },
  {
    n: "02",
    title: "A network without borders.",
    body: "We represent premier cement and steel producers across Asia, forming a global network that moves material where it is needed, when it is needed.",
  },
  {
    n: "03",
    title: "Logistics as a discipline.",
    body: "Tech-driven supply-chain management and strict bulk-trade policy turn distribution into a precise, measurable science.",
  },
];

export const SERVICES = [
  {
    title: "Bulk Acquisition",
    desc: "Sourcing strategies engineered around your trading goals — negotiated at volume, secured with certainty.",
    img: IMAGES.steelDark,
    span: "lg:col-span-7",
  },
  {
    title: "Logistics Management",
    desc: "Seamless distribution across ports, rail and road with real-time visibility.",
    img: IMAGES.logisticsYard,
    span: "lg:col-span-5",
  },
  {
    title: "Market Insights",
    desc: "Real-time analysis and timely intelligence to inform every bulk decision.",
    img: IMAGES.cement,
    span: "lg:col-span-5",
  },
  {
    title: "Global Network Expansion",
    desc: "Representing world-class cement & steel companies to build one connected trade network.",
    img: IMAGES.heroAlt,
    span: "lg:col-span-7",
  },
];

export const MATERIALS = [
  { idx: "M/01", name: "Vizag Steel TMT Bars", spec: "Fe 500 / Fe 550D · 8mm–40mm", img: IMAGES.steelPersp },
  { idx: "M/02", name: "Premium Cement", spec: "OPC 53 · PPC · Bulk & Bagged", img: IMAGES.cementFactory },
  { idx: "M/03", name: "Structural Steel", spec: "Beams · Channels · Plates", img: IMAGES.steelRed },
  { idx: "M/04", name: "Aggregate & Ancillary", spec: "Sourced · Graded · Certified", img: IMAGES.logisticsShip },
];

export const PROJECTS = [
  { title: "Meridian Supertall Tower", location: "Mumbai", scope: "48,000 T TMT + 1.2M bags cement", img: IMAGES.projSkyscraper },
  { title: "Deepwater Port Expansion", location: "Chennai", scope: "Structural steel · 30,000 T package", img: IMAGES.projPort },
  { title: "Estuary Cable-Stayed Bridge", location: "Kolkata", scope: "High-tensile TMT · 22,000 T", img: IMAGES.projBridge },
  { title: "Integrated Steel Complex", location: "Vizag", scope: "Bulk raw material programme", img: IMAGES.projSteelplant },
  { title: "Trans-State Expressway", location: "Nagpur–Mumbai", scope: "Cement + aggregate · 180 km", img: IMAGES.projExpressway },
  { title: "Skyline Mega-Township", location: "Hyderabad", scope: "14-tower cluster · full material supply", img: IMAGES.projTowerComplex },
];

export const STATS = [
  { value: "6.8M+", label: "Tonnes traded" },
  { value: "320+", label: "Projects supplied" },
  { value: "28", label: "States served" },
  { value: "40+", label: "Producer partners" },
];

export const PROJECT_SCALE = [
  { value: "₹4,200 Cr+", label: "Material value delivered" },
  { value: "28 States", label: "Coverage · PAN-India" },
  { value: "320+", label: "Landmark projects" },
  { value: "99.4%", label: "On-time dispatch" },
];

// A comprehensive ledger of executed supply programmes — conveys the scale of the portfolio.
export const PROJECT_LEDGER = [
  { project: "Meridian Supertall Tower", location: "Mumbai, MH", material: "TMT + OPC 53 Cement", tonnage: "48,000 T", year: "2025", status: "Delivered" },
  { project: "Deepwater Port Expansion", location: "Chennai, TN", material: "Structural Steel", tonnage: "30,000 T", year: "2025", status: "Delivered" },
  { project: "Estuary Cable-Stayed Bridge", location: "Kolkata, WB", material: "High-tensile TMT", tonnage: "22,000 T", year: "2024", status: "Delivered" },
  { project: "Integrated Steel Complex", location: "Visakhapatnam, AP", material: "Bulk Raw Material", tonnage: "1.1M T", year: "2024", status: "Delivered" },
  { project: "Trans-State Expressway", location: "Nagpur–Mumbai", material: "Cement + Aggregate", tonnage: "260,000 T", year: "2025", status: "In progress" },
  { project: "Skyline Mega-Township", location: "Hyderabad, TS", material: "Full Material Supply", tonnage: "85,000 T", year: "2025", status: "In progress" },
  { project: "Coastal Refinery Phase II", location: "Jamnagar, GJ", material: "Structural + Plates", tonnage: "54,000 T", year: "2024", status: "Delivered" },
  { project: "Metro Rail Corridor", location: "Bengaluru, KA", material: "TMT Fe 550D", tonnage: "38,500 T", year: "2025", status: "In progress" },
  { project: "IT SEZ Campus", location: "Pune, MH", material: "Cement + TMT", tonnage: "26,000 T", year: "2023", status: "Delivered" },
  { project: "Riverfront Development", location: "Ahmedabad, GJ", material: "Cement + Aggregate", tonnage: "44,000 T", year: "2024", status: "Delivered" },
  { project: "Airport Terminal Expansion", location: "Delhi (NCR)", material: "Structural Steel", tonnage: "41,000 T", year: "2025", status: "In progress" },
  { project: "Thermal Power Station", location: "Korba, CG", material: "Plates & Sheets", tonnage: "33,000 T", year: "2023", status: "Delivered" },
  { project: "Smart City Housing", location: "Lucknow, UP", material: "Cement (PPC)", tonnage: "58,000 T", year: "2024", status: "Delivered" },
  { project: "Container Freight Terminal", location: "Mundra, GJ", material: "TMT + Binding Wire", tonnage: "19,500 T", year: "2023", status: "Delivered" },
  { project: "Coastal Highway Package", location: "Panaji, GA", material: "Cement + Aggregate", tonnage: "72,000 T", year: "2025", status: "In progress" },
  { project: "Industrial Logistics Park", location: "Bhiwandi, MH", material: "Structural Steel", tonnage: "28,000 T", year: "2024", status: "Delivered" },
  { project: "Hydroelectric Barrage", location: "Dehradun, UK", material: "TMT + Cement", tonnage: "36,000 T", year: "2023", status: "Delivered" },
  { project: "Waterfront Convention Centre", location: "Kochi, KL", material: "Structural + TMT", tonnage: "24,000 T", year: "2025", status: "In progress" },
  { project: "Ring Road Interchange", location: "Jaipur, RJ", material: "Cement + Aggregate", tonnage: "63,000 T", year: "2024", status: "Delivered" },
  { project: "Steel Fabrication Yard", location: "Raipur, CG", material: "Plates & Structural", tonnage: "31,000 T", year: "2023", status: "Delivered" },
  { project: "Coastal Cargo Berth", location: "Paradip, OD", material: "TMT Fe 500", tonnage: "27,500 T", year: "2024", status: "Delivered" },
  { project: "Mixed-Use Business Park", location: "Gurugram, HR", material: "Full Material Supply", tonnage: "49,000 T", year: "2025", status: "In progress" },
  { project: "Elevated Corridor", location: "Patna, BR", material: "TMT + Cement", tonnage: "34,500 T", year: "2024", status: "Delivered" },
  { project: "Data Centre Campus", location: "Navi Mumbai, MH", material: "Structural Steel", tonnage: "21,000 T", year: "2025", status: "In progress" },
];

// Map a ledger row's location to a full state name (shared by ledger filters + map deep-dive).
const LEDGER_STATE_ABBR = {
  MH: "Maharashtra", TN: "Tamil Nadu", WB: "West Bengal", AP: "Andhra Pradesh",
  TS: "Telangana", GJ: "Gujarat", KA: "Karnataka", CG: "Chhattisgarh",
  UP: "Uttar Pradesh", GA: "Goa", UK: "Uttarakhand", KL: "Kerala",
  RJ: "Rajasthan", OD: "Odisha", HR: "Haryana", BR: "Bihar",
};
export const ledgerRowState = (loc) => {
  const m = loc.match(/,\s*([A-Z]{2})$/);
  if (m) return LEDGER_STATE_ABBR[m[1]] || m[1];
  if (loc.includes("Delhi")) return "Delhi";
  if (loc.includes("Nagpur") || loc.includes("Mumbai")) return "Maharashtra";
  return loc;
};
export const LEDGER_STATES = Array.from(new Set(PROJECT_LEDGER.map((r) => ledgerRowState(r.location)))).sort();
export const projectsByState = (stateName) => PROJECT_LEDGER.filter((r) => ledgerRowState(r.location) === stateName);


export const GROUP = {
  kicker: "/ The Vinci Group",
  headline: "One name. A structured conglomerate.",
  body: "Vinci Inc. executes bulk build-to-ship orders across India through a purpose-built structure of subsidiaries — floated per State and per project to meet local legal and compliance requirements without ever slowing the trade.",
  pillars: [
    { title: "Private Limited", tag: "Flagship", desc: "Flagship companies anchoring large, multi-state programmes.", detail: "Our Private Limited companies carry the largest mandates — multi-state supply programmes, institutional buyers and long-cycle infrastructure where scale, governance and balance-sheet strength matter most." },
    { title: "LLP & Partnership", tag: "Regional", desc: "Agile vehicles for regional projects and joint execution.", detail: "Limited Liability Partnerships and Partnership firms let us move fast on regional projects and co-execute with local partners, sharing risk while keeping delivery tight and accountable." },
    { title: "Designated LLPs", tag: "Specialised", desc: "Compliance-optimised entities for specialised mandates.", detail: "Purpose-built LLPs handle specialised mandates and compliance-sensitive contracts, structured entity-by-entity so every engagement sits within the right legal and tax envelope." },
    { title: "Proprietorships", tag: "Rapid", desc: "Lean licenses for smaller States and rapid mobilisation.", detail: "Designated proprietorship licenses give us a lean, rapid footprint in smaller States — mobilising supply quickly wherever a project demands a local, compliant presence." },
  ],
  stats: [
    { value: 28, suffix: "", label: "States operated in" },
    { value: 40, suffix: "+", label: "Group & partner entities" },
    { value: 320, suffix: "+", label: "Projects executed" },
    { value: 100, suffix: "%", label: "Compliant, State-wise billing" },
  ],
  states: [
    "Maharashtra", "Gujarat", "Karnataka", "Tamil Nadu", "Telangana", "Andhra Pradesh",
    "Kerala", "Goa", "Madhya Pradesh", "Rajasthan", "Uttar Pradesh", "Delhi",
    "Haryana", "Punjab", "Bihar", "Jharkhand", "West Bengal", "Odisha",
    "Chhattisgarh", "Assam", "Uttarakhand", "Himachal Pradesh", "Jammu & Kashmir",
    "Tripura", "Meghalaya", "Puducherry", "Chandigarh", "Andaman & Nicobar",
  ],
};
